import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  Action_SaveKho,
  Action_GetDanhSachKho,
  Action_GetChiTietKho,
  Action_DeleteKho,
  Action_LockUnlock,
} from "actions/Kho/actionTypes";
import {
  Index_SaveKhoSuccess,
  Index_SaveKhoFailed,
  Index_GetDanhSachKhoSuccess,
  Index_GetChiTietKhoSuccess,
  Index_DeleteKhoSuccess,
  Index_DeleteKhoFailed,
  Index_LockUnlockKhoSuccess,
  Index_LockUnlockKhoFailed,
} from "actions/Kho";
import khoApi from "service/khoApi";
import { pushNotification } from "utils/notifications";
import { CheckTokenReload } from "utils/utils";

//Region api Lưu dữ liệu KHO
function* Saga_saveKho(action) {
  try {
    const response = yield call(khoApi.saveKho, action.payload);
    CheckTokenReload(response);
    if (response.status == 200) {
      pushNotification("Thêm mới kho thành công", "success", "TOP_RIGHT", 2000);
      yield put(Index_SaveKhoSuccess(response.data));
    } else {
      pushNotification(response.status, "error", "TOP_RIGHT", 2000);
      yield put(Index_SaveKhoFailed(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}
function* watch_saveKho() {
  yield takeLatest(Action_SaveKho, Saga_saveKho);
}
//endregion watchAPI

//Region api Lấy danh sách kho
function* Saga_DanhSachKho(action) {
  try {
    const response = yield call(khoApi.getDanhSachKho, action.payload);
    CheckTokenReload(response);
    if (response.status == 200) {
      yield put(Index_GetDanhSachKhoSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}
function* watch_DanhSachKho() {
  yield takeLatest(Action_GetDanhSachKho, Saga_DanhSachKho);
}
//endregion watchAPI

//#region Lấy chi tiết kho

function* Saga_ChiTietKho(action) {
  try {
    const response = yield call(khoApi.getChiTietKho, action.payload);
    CheckTokenReload(response);
    if (response.status == 200) {
      yield put(Index_GetChiTietKhoSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}
function* watch_ChiTietKho() {
  yield takeLatest(Action_GetChiTietKho, Saga_ChiTietKho);
}
//#endregion

//Region api Lưu dữ liệu KHO
function* Saga_deleteKho(action) {
  try {
    const response = yield call(khoApi.deleteKho, action.payload);
    CheckTokenReload(response);
    if (response.status == 200) {
      pushNotification("Xóa kho thành công", "success", "TOP_RIGHT", 2000);
      yield put(Index_DeleteKhoSuccess(response.data));
    } else {
      pushNotification(response.status, "error", "TOP_RIGHT", 2000);
      yield put(Index_DeleteKhoFailed(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}
function* watch_deleteKho() {
  yield takeLatest(Action_DeleteKho, Saga_deleteKho);
}

function* Saga_lockUnlockKho(action) {
  try {
    const response = yield call(khoApi.khoaMoKhoa, action.payload);
    CheckTokenReload(response);
    if (response.status == 200) {
      pushNotification(response.data, "success", "TOP_RIGHT", 2000);
      yield put(Index_LockUnlockKhoSuccess(response.data));
    } else {
      pushNotification(response.status, "error", "TOP_RIGHT", 2000);
      yield put(Index_LockUnlockKhoFailed(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}
function* watch_lockUnlockKho() {
  yield takeLatest(Action_LockUnlock, Saga_lockUnlockKho);
}
//endregion watchAPI

export default function* sagas() {
  yield all([
    watch_saveKho(),
    watch_DanhSachKho(),
    watch_ChiTietKho(),
    watch_deleteKho(),
    watch_lockUnlockKho(),
  ]);
}
